import script from "./EmojiItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmojiItem.vue?vue&type=script&setup=true&lang=ts"

import "./EmojiItem.vue?vue&type=style&index=0&id=73b4c24a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73b4c24a"]])

export default __exports__